module.exports = __webpack_public_path__ + "img/xbanner02.428c67a1.png";